<template>
  <div>
      <button
      type="button"
      class="btn btn-primary btn-with-addon"
      @click="showModal"
    >
      <span class="btn-addon">
        <i class="btn-addon-icon fe fe-plus-circle" />
      </span>
      Add Discipline
    </button>
  <a-modal
    :visible="visible"
    title="Add Discipline Record"
    okText="Save"
    cancelText="Cancel"
    :confirmLoading="submitting"
    @ok="handleSubmit"
    @cancel="handleCancel"
    width="700px"
  >
    <a-form :form="form" layout="vertical">
      <!-- Student -->
      <div class="row">
    <!-- Session Dropdown -->
    <div class="col-md-6 col-12">
      <a-form-item label="Session">
        <a-select
          placeholder="Select Session"
          v-decorator="['session_id', { rules: [{ required: true, message: 'Please select a session' }] }]"
          @change="handleSessionChange"
        >
          <a-select-option
            v-for="s in sessions"
            :key="s.id"
            :value="s.id"
          >
            {{ s.name }}
            <small v-if="s.is_current === 1" class="text-primary ml-1">(Current)</small>
          </a-select-option>
        </a-select>
      </a-form-item>
    </div>

    <!-- Class Dropdown -->
    <div class="col-md-6 col-12">
      <a-form-item label="Class">
        <a-select
          placeholder="Select Class"
          v-decorator="['class_id', { rules: [{ required: true, message: 'Please select a class' }] }]"
          @change="handleClassChange"
        >
          <a-select-option
            v-for="c in classes"
            :key="c.id"
            :value="c.id"
          >
            {{ c.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
    </div>
  </div>

      <a-form-item label="Student">
        <a-select
          show-search
          placeholder="Select Student"
          :filterOption="false"
          @search="onSearchStudent"
          @popupScroll="onScrollStudent"
          v-decorator="[
            'student_id',
            { rules: [{ required: true, message: 'Please select a student' }] }
          ]"
        >
          <a-select-option
            v-for="student in students"
            :key="student.id"
            :value="student.id"
          >
            {{ student.first_name }} {{ student.last_name }}
            <span v-if="student.enrollment && student.enrollment.length > 0" class="text-muted ml-1">
              [{{ student.enrollment[0].school_class ? student.enrollment[0].school_class.name : '' }},
               {{ student.enrollment[0].section ? student.enrollment[0].section.name : '' }},
               {{ student.enrollment[0].roll_no ? 'Roll: ' + student.enrollment[0].roll_no : '' }}]
            </span>
          </a-select-option>

          <!-- notFoundContent slot (shows spinner while loading) -->
          <template slot="notFoundContent">
            <a-spin v-if="studentLoading" size="small" />
            <span v-else>No students found</span>
          </template>
        </a-select>
      </a-form-item>

      <!-- Incident Date -->
      <a-form-item label="Incident Date">
        <a-date-picker
          style="width: 100%"
          :format="dateFormat"
          v-decorator="[
            'incident_date',
            { initialValue: moment(), rules: [{ required: true, message: 'Please pick a date' }] }
          ]"
        />
      </a-form-item>

      <!-- Category -->
      <a-form-item label="Category">
        <a-select
          placeholder="Select Category"
          v-decorator="['category_id', { rules: [{ required: false, message: 'Please select a category' }] }]"
        >
          <a-select-option
            v-for="c in categories"
            :key="c.id"
            :value="c.id"
          >
            {{ c.name }}
          </a-select-option>
        </a-select>
      </a-form-item>

      <!-- Description -->
      <a-form-item label="Description">
        <a-textarea
          rows="3"
          v-decorator="[
            'description',
            { rules: [{ required: true, message: 'Please enter description' }] }
          ]"
        />
      </a-form-item>

      <!-- Mark as Penalty -->
      <a-form-item>
        <a-checkbox v-model="showPenaltyFields">Mark as Penalty</a-checkbox>
      </a-form-item>

      <template v-if="showPenaltyFields">
        <a-form-item label="Penalty Type">
          <a-select
            placeholder="Select Penalty"
            v-decorator="['penalty_id']"
          >
            <a-select-option
              v-for="p in penalties"
              :key="p.id"
              :value="p.id"
            >
              {{ p.name }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item label="Penalty Details">
          <a-input v-decorator="['penalty_details']" placeholder="Optional details" />
        </a-form-item>
      </template>

      <!-- Severity -->
      <a-form-item label="Severity">
        <a-radio-group v-decorator="['severity', { initialValue: 'Minor', rules: [{ required: true }] }]">
          <a-radio value="minor">Minor</a-radio>
          <a-radio value="medium">Medium</a-radio>
          <a-radio value="major">Major</a-radio>
        </a-radio-group>
      </a-form-item>

      <!-- Reported By -->
      <a-form-item label="Reported By">
        <a-select
          show-search
          option-filter-prop="children"
          placeholder="Select Reporter"
          v-decorator="['reported_by', { rules: [{ required: true, message: 'Please select reporter' }] }]"
        >
          <a-select-option
            v-for="teacher in teachers"
            :key="teacher.id"
            :value="teacher.id"
          >
            {{ teacher.first_name }} {{ teacher.last_name }}
          </a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
  </a-modal>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'AddDisciplineForm',
  data() {
    return {
      submitting: false,
      dateFormat: 'YYYY-MM-DD',
      showPenaltyFields: false,
      students: [],
      selectedStudent: undefined,
      studentSpinning: false,
      studentPagination: {
        current: 1,
        last: 1,
        perPage: 10,
        total: 0,
      },
      studentSearch: '',
      visible: false,
      studentLoading: false,
      sessions: [],
      currentSessionId: null,
      categories: [],
      penalties: [],
      teachers: [],
      classes: [],
    }
  },
  created() {
    this.form = this.$form.createForm(this)
  },
  mounted() {
    this.fetchStudents()
    this.getCategories()
    this.getPenalties()
    this.getTeachers()
    this.getClasses()
  },
  methods: {
    moment,
    showModal() {
      this.visible = true
      this.getSessions()
    },
    getSessions() {
      this.$http.get('/api/session')
        .then(({ data }) => {
          this.sessions = data.data
          const current = this.sessions.find(s => s.is_current === 1)
          this.currentSessionId = current ? current.id : null
          // Set default session in form
          this.$nextTick(() => {
            // Only set if form is visible and rendered
            if (this.visible) {
              this.form.setFieldsValue({ session_id: this.currentSessionId })
            }
          })
          // Fetch classes for that session
          this.getClasses(this.currentSessionId)
        })
        .catch(err => console.log(err))
    },

    getCategories() {
      this.$http.get('/api/student-discipline-category')
        .then(({ data }) => (this.categories = data.data))
        .catch(() => {})
    },
    getPenalties() {
      this.$http.get('/api/discipline-penalty')
        .then(({ data }) => (this.penalties = data.data))
        .catch(() => {})
    },
    getTeachers() {
      let teachers = []
      let currentPage = 1
      let totalPages = 1

      // First, get the first page
      this.$http.get('/api/teacher/', { params: { page: currentPage } })
        .then(firstPageResponse => {
          const firstPageData = firstPageResponse.data
          teachers = [...teachers, ...firstPageData.data]

          // Check pagination metadata
          if (firstPageData.meta && firstPageData.meta.last_page) {
            totalPages = firstPageData.meta.last_page
          }

          if (totalPages > 1) {
            const pagePromises = []

            for (let page = 2; page <= totalPages; page++) {
              pagePromises.push(
                this.$http.get('/api/teacher/', { params: { page } })
              )
            }

            // Fetch all remaining pages in parallel
            return Promise.all(pagePromises).then(responses => {
              responses.forEach(response => {
                teachers = [...teachers, ...response.data.data]
              })
              return teachers
            })
          } else {
            return teachers
          }
        })
        .then(teachersResult => {
          this.teachers = teachersResult
          console.log(`Loaded ${this.teachers.length} teachers from ${totalPages} pages`)
        })
        .catch(error => {
          console.error('Failed to fetch teachers', error)
          this.$notification.error({
            message: 'Failed to load teachers',
            description: 'Please try again later.',
          })
        })
    },
    getClasses(sessionId) {
      this.$http.get('/api/class', { params: { session_id: sessionId } })
        .then(({ data }) => { this.classes = data.data })
    },
    fetchStudents(search = '', page = 1, classId = null, sessionId = null) {
      this.studentLoading = true
      this.studentSearch = search
      const params = {
        search: search,
        page: page,
        per_page: this.studentPagination.perPage,
      }

      // include class filter if available
      if (classId) {
        params.class_id = classId
      }
      if (sessionId) {
        params.session_id = sessionId
      }

      this.$http.get('/api/student', { params })

        .then((response) => {
          const data = response.data
          const studentList = data.data
          const meta = data.meta

          if (page === 1) {
            this.students = studentList
          } else {
            this.students = this.students.concat(studentList)
          }

          // Update pagination
          this.studentPagination.current = meta.current_page
          this.studentPagination.last = meta.last_page
          this.studentPagination.total = meta.total
        })
        .catch((error) => {
          console.error('Error fetching students:', error)
          const msg = (error && error.message) ? error.message : 'Failed to fetch students'
          this.$message.error(msg)
        })
        .finally(() => {
          this.studentLoading = false
        })
    },
    handleSessionChange(sessionId) {
    // reset class when session changes
      this.form.setFieldsValue({ class_id: undefined })
      this.getClasses(sessionId)
    },
    handleClassChange(classId) {
      // Reset student field when class changes
      this.form.setFieldsValue({ student_id: undefined })
      this.students = []

      const sessionId = this.form.getFieldValue('session_id') || this.currentSessionId

      if (classId) {
        this.fetchStudents('', 1, classId, sessionId)
      }
    },

    onSearchStudent(value) {
      const classId = this.form.getFieldValue('class_id')
      const sessionId = this.form.getFieldValue('session_id') || this.currentSessionId
      this.fetchStudents(value, 1, classId, sessionId)
    },

    // handle infinite scroll
    onScrollStudent(e) {
      const { scrollTop, scrollHeight, clientHeight } = e.target
      const isNearBottom = scrollTop + clientHeight >= scrollHeight - 10

      if (
        isNearBottom &&
      !this.studentLoading &&
      this.studentPagination.current < this.studentPagination.last
      ) {
        const classId = this.form.getFieldValue('class_id')
        const sessionId = this.form.getFieldValue('session_id') || this.currentSessionId

        this.fetchStudents(
          this.studentSearch,
          this.studentPagination.current + 1,
          classId,
          sessionId
        )
      }
    },

    handleSubmit() {
      this.form.validateFields((err, values) => {
        if (err) {
          return
        }
        this.submitting = true
        const payload = {
          ...values,
          incident_date: values.incident_date ? values.incident_date.format('YYYY-MM-DD') : null,
        }
        this.$http.post('/api/student-discipline', payload)
          .then(() => {
            this.$notification.success({
              message: 'Added Successfully!',
              description: 'Discipline record has been added successfully.',
            })
            this.$emit('created')
            this.visible = false
            this.form.resetFields()
            this.showPenaltyFields = false
          })
          .catch((error) => {
            const msg = (error && error.message) ? error.message : 'Failed to add record'
            this.$message.error(msg)
          })
          .finally(() => (this.submitting = false))
      })
    },
    handleCancel() {
      this.form.resetFields()
      this.showPenaltyFields = false
      this.visible = false
    },
  },
}
</script>
